import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

// Small read-only line showing how a Moment began.
export const OriginBadge = ({ moment, className = '' }) => {
  const label = moment?.origin?.label;
  const note = moment?.origin_note;
  if (!label && !note) return null;
  return (
    <p className={`flex items-start gap-1.5 text-xs font-semibold text-slate-500 break-words ${className}`}>
      <SafeIcon icon={FiIcons.FiMapPin} className="mt-0.5 shrink-0 text-slate-400" />
      <span>{[label, note].filter(Boolean).join(' · ')}</span>
    </p>
  );
};